<template>
    <SwitchRoot :id="id" :disabled="disabled" :class="rootClasses">
        <SwitchThumb :class="thumbClasses" />
    </SwitchRoot>
</template>

<script setup lang="ts">
import { SwitchRoot, SwitchThumb } from "reka-ui";
import { computed } from "vue";

export type SwitchSize = "sm" | "md" | "lg";

type BaseSwitchProps = {
    id?: string;
    disabled?: boolean;
    size?: SwitchSize;
};

const props = withDefaults(defineProps<BaseSwitchProps>(), {
    disabled: false,
    size: "lg",
});

const rootClasses = computed(() => {
    const base = "flex rounded-full relative transition-colors data-disabled:cursor-not-allowed data-disabled:opacity-50";
    const unchecked = "data-[state=unchecked]:bg-switch-off hover:data-[state=unchecked]:bg-switch-off-hover";
    const checked = "data-[state=checked]:bg-switch-on";

    const sizeMap: Record<SwitchSize, string> = {
        sm: "min-w-7.5 h-4",
        md: "min-w-9 h-5",
        lg: "min-w-12.5 h-7.5",
    };

    return [base, unchecked, checked, sizeMap[props.size]];
});

const thumbClasses = computed(() => {
    const base = "my-auto bg-switch-thumb rounded-full transition-transform will-change-transform shadow-xl";

    const sizeMap: Record<SwitchSize, string> = {
        sm: "min-w-3 h-3 translate-x-0.5 data-[state=checked]:translate-x-[calc(100%+3px)]",
        md: "min-w-4 h-4 translate-x-0.5 data-[state=checked]:translate-x-[calc(100%+1px)]",
        lg: "min-w-6 h-6 translate-x-0.75 data-[state=checked]:translate-x-[calc(100%-2px)]",
    };

    return [base, sizeMap[props.size]];
});
</script>
